<template>
  <div class="finance-page main-wrapper history-page">
    <div class="finance-page__inner px-2 px-md-3 pt-2">
      <h3 class="finance-page__title">
        {{
          $store.state.language === 'en'
            ? 'Betslip History'
            : 'ဘောက်ချာများ'
        }}
      </h3>

      <div class="finance-panel history-toolbar">
        <div
          class="history-type-pills"
          role="group"
          :aria-label="$store.state.language === 'en' ? 'Betslip type' : 'ဘောက်ချာ အမျိုးအစား'"
        >
          <button
            type="button"
            class="history-pill"
            :class="{ 'history-pill--active': type === 'maung' }"
            @click="changeType('maung'); fetchHistory()"
          >
            {{ $store.state.language === 'en' ? 'Maung' : 'မောင်း' }}
          </button>
          <button
            type="button"
            class="history-pill"
            :class="{ 'history-pill--active': type === 'body' }"
            @click="changeType('body'); fetchHistory()"
          >
            {{ $store.state.language === 'en' ? 'Body' : 'ဘော်ဒီ' }}
          </button>
        </div>

        <div
          v-if="type === 'twod' || type === 'threed'"
          class="history-bingo-row mb-2"
        >
          <b-form-checkbox
            v-model="isBingo"
            size="lg"
            class="history-bingo-check"
            @change="fetchHistory()"
          />
          <span class="history-bingo-label">{{
            $store.state.language === 'en' ? 'Bingo?' : 'ပေါက်ဂဏန်းပါ'
          }}</span>
        </div>

        <div class="history-date-row history-date-row--betslip">
          <div
            v-if="type === 'twod'"
            class="history-date-select transaction history-date-select--draw"
          >
            <label class="finance-label history-date-label">{{
              $store.state.language === 'en' ? 'Draw' : 'အချိန်'
            }}</label>
            <TwoDSelect
              type="draw"
              :data="params"
              field="draw"
            />
          </div>

          <div
            v-if="type === 'threed'"
            class="history-date-select transaction"
          >
            <label class="finance-label history-date-label">{{
              $store.state.language === 'en' ? 'Draw' : 'အချိန်'
            }}</label>
            <v-select
              v-model="params.date"
              :reduce="(draw) => draw.data"
              label="label"
              :options="dateOptionsThreed"
            />
          </div>

          <div
            v-else
            class="history-date-select transaction"
          >
            <label class="finance-label history-date-label">{{ $t('football.date') }}</label>
            <v-select
              v-model="params.date"
              :reduce="(draw) => draw.data"
              label="label"
              :options="dateOptions"
            />
          </div>

          <button
            type="button"
            class="btn finance-btn-primary history-search-btn"
            @click="fetchHistory"
          >
            {{ $t('transaction.search') }}
          </button>
        </div>
      </div>

      <div class="finance-panel history-table-panel mt-3">
        <div
          v-if="isLoading"
          class="history-loading"
        >
          <Loading
            color="#dc2626"
            size="24"
            class="px-4 py-0"
          />
          <span class="history-loading-text">{{ $t('please_wait') }}</span>
        </div>
        <template v-else>
          <div class="history-table-scroll">
            <table class="table align-items-center table-flush betslip-data-table">
              <thead>
                <tr>
                  <th class="betslip-th">
                    {{
                      $store.state.language === 'en'
                        ? 'Voucher Id'
                        : 'ဘောက်ချာနံပါတ်'
                    }}
                  </th>
                  <th class="betslip-th">
                    {{
                      $store.state.language === 'en'
                        ? 'Remark'
                        : 'မှတ်ချက်'
                    }}
                  </th>
                  <th
                    v-if="isBingo"
                    class="betslip-th"
                  >
                    {{
                      $store.state.language === 'en'
                        ? 'Bingo Amount'
                        : 'ပေါက်ဂဏန်း ပမာဏ'
                    }}
                  </th>
                  <th class="betslip-th">
                    {{
                      $store.state.language === 'en'
                        ? 'Total Amount'
                        : 'စုစုပေါင်း'
                    }}
                  </th>
                  <th class="betslip-th">
                    {{
                      $store.state.language === 'en'
                        ? 'Bet Date'
                        : 'ထိုးသည့်နေ့စွဲ'
                    }}
                  </th>
                </tr>
              </thead>
              <tbody class="list">
                <tr
                  v-for="(history, index) in betHistoryList"
                  :key="index"
                  class="betslip-data-table__row"
                  @click="getSlipdata(history)"
                >
                  <td class="betslip-data-table__td">
                    <span class="betslip-data-table__value">{{ history.voucher_id }}</span>
                  </td>
                  <td class="betslip-data-table__td betslip-data-table__td--center">
                    <span
                      v-if="!history.isBet"
                      class="betslip-pill betslip-pill--warn"
                    >Incomplete</span>
                    <span
                      v-else-if="history.bingo_amount > 0 || history.is_bingo"
                      class="betslip-remark-ok"
                    ><i class="fas fa-check text-success" /></span>
                    <span
                      v-else
                      class="betslip-remark-bad"
                    ><i class="fas fa-times text-danger" /></span>
                  </td>
                  <td
                    v-if="isBingo"
                    class="betslip-data-table__td"
                  >
                    <span class="betslip-data-table__value">{{ history.bingo_amount }}</span>
                  </td>
                  <td class="betslip-data-table__td">
                    <span class="betslip-data-table__value">{{ history.total_amount }}</span>
                  </td>
                  <td class="betslip-data-table__td">
                    <span class="betslip-data-table__muted">{{ betDate(history.created_at) }}</span>
                  </td>
                </tr>
                <tr class="betslip-data-table__summary">
                  <td class="betslip-data-table__td" />
                  <td class="betslip-data-table__td" />
                  <td
                    v-if="isBingo"
                    class="betslip-data-table__td"
                  >
                    <span class="betslip-summary-label">
                      Total —
                      <b class="text-danger">{{ Number(totalBingoAmount()).toLocaleString() }}</b>
                    </span>
                  </td>
                  <td class="betslip-data-table__td">
                    <span class="betslip-summary-label">
                      Total —
                      <b class="text-success">{{ Number(totalVoucherAmount()).toLocaleString() }}</b>
                    </span>
                  </td>
                  <td class="betslip-data-table__td" />
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>

    <div
      id="voucher-history"
      ref="captureElement"
      class="modal fade history-voucher-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content history-voucher-modal__content">
          <div class="history-voucher-modal__toolbar">
            <button
              type="button"
              class="btn history-capture-btn"
              @click="captureThisVoucher()"
            >
              <i class="fas fa-camera mr-1" />
              {{
                $store.state.language === 'en' ? 'Screenshot' : 'ဓာတ်ပုံ'
              }}
            </button>
            <div
              class="text-center modal-cross history-modal-cross"
              @click="closeModal"
            >
              X
            </div>
          </div>
          <div class="modal-body p-0">
            <div id="capture">
              <FBVoucher
                v-if="type === 'maung' || type === 'body' || type === '1x2' || type === 'correctScore'"
                :type="type"
                :datas="datas"
                :slip-id="slipId"
                :current-time="bet_date"
                :is-history="true"
                :is_result="is_result"
                :bingo_amount="bingo_amount"
              />
              <Voucher
                v-else
                type="history"
                :datas="datas"
                :slip-id="slipId"
                :current-time="bet_date"
                :is-twod="isTwod"
                :name="name"
                :remark="remark"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import SideNav from './components/SideNav.vue';
import Voucher from './components/Voucher.vue';
import { DateTime } from 'luxon';
import { Loading, Dialog, Toast } from 'vant';
import FBVoucher from './components/FBVoucher.vue';
import html2canvas from 'html2canvas';
import { mapActions } from 'vuex';
import TwoDSelect from './components/TwoDSelect.vue';

export default {
  components: {
    TwoDSelect,
    // SideNav,
    Voucher,
    Loading,
    FBVoucher,
  },
  computed: {
    betHistoryList() {
      const h = this.betHistory;
      return Array.isArray(h) ? h : [];
    },
  },
  data() {
    return {
      isLoading: false,
      isBingo: false,
      type: 'maung',
      remark: '',
      name: '',
      searchKeyword: '',
      params: {
        draw: '',
        date: '',
      },
      dateOptionsThreed: [
        {
          label: null,
          data: null,
        },
        {
          label: null,
          data: null,
        },
      ],
      dateOptions: [],
      betHistory: [],
      datas: [],
      slipId: null,
      bet_date: null,
      isTwod: true,
      bingo_amount: null,
      is_result: false,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    async captureThisVoucher() {
        Dialog.confirm({
            title:
            this.$store.state.language === 'en'
                ? 'Are you sure to take screenshot?'
                : 'ဓာတ်ပုံအနေဖြင့် သိမ်းမှာ သေချာပါသလား?',
            cancelButtonText:
            this.$store.state.language === 'en' ? 'Cancel' : 'မသိမ်းတော့ပါ',
            confirmButtonText:
            this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
        }).then(async () => {
                await this.captureElement();
            Toast.success(
                this.$store.state.language === 'en' ? 'DONE!' : 'ပြီးပြီ'
            );
        }).catch(() => {});
        
    },
    async captureElement() {
      try {
        // Ensure the element exists before capturing it
        const element = document.getElementById('capture');
        if (!element) {
          console.error('Element not found');
          return;
        }

        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL('image/png');

        // Create a link element for downloading the captured image
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'screenshot.png';
        link.click();
      } catch (error) {
        console.error('Error capturing element:', error);
      }
    },
    totalVoucherAmount() {
      let total = 0;
      for (let i = 0; i < this.betHistoryList.length; i += 1) {
        total += parseInt(this.betHistoryList[i].total_amount, 10);
      }
      return total;
    },
    totalBingoAmount() {
      let total = 0;
      for (let i = 0; i < this.betHistoryList.length; i += 1) {
        total += parseInt(this.betHistoryList[i].bingo_amount, 10);
      }
      return total;
    },
    setLastHalfMonth() {
      this.dateOptionsThreed[0].label = 'Current Draw';
      this.dateOptionsThreed[0].data = 'current';

      this.dateOptionsThreed[1].label = 'Last Draw';
      this.dateOptionsThreed[1].data = 'last';

      this.params.date = 'current';
    },
    changeType(type) {
      if (type === 'threed') {
        this.setLastHalfMonth();
      } else {
        this.params.date = moment(new Date()).format('l');
        this.params.draw = this.currentDraw();
      }
      this.type = type;
    },
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format('l');
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    async getSlipdata(data) {
      try {
        if (this.type !== 'maung' && this.type !== 'body' && this.type !== '1x2' && this.type !== 'correctScore') {
          const res = await axios.post('vouchers/datas', {
            voucher_id: data.id,
            type: data.type,
          }, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
              });
          this.isTwod = data.type === 'twod';
          this.slipId = data.id;
          this.name = data.name;
          this.remark = data.remark;
          this.bet_date = data.type === 'twod'
            ? this.betTime(data.created_at)
            : this.betTime(data.created_at);
          this.datas = res.data.data;
          $('#voucher-history').modal('show');
        } else {
          this.datas = data.team_vouchers;
          this.bingo_amount = data.bingo_amount;
          this.slipId = data.id;
          this.is_result = data.isBet;
          this.type = data.type;
          this.bet_date = this.betTime(data.created_at);
          $('#voucher-history').modal('show');
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHistory() {
      try {
        this.isLoading = true;
        let res;
        if (this.type === 'twod' || this.type === 'threed') {
          res = await axios.post('/vouchers/datas/all', {
            draw: this.params.draw,
            date: this.params.date,
            search: this.searchKeyword,
            isBingo: this.isBingo,
            type: this.type,
          }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
        } else {
          res = await axios.post('/fb-vouchers-history', {
            draw_date: this.params.date,
            type: this.type,
          }, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  },
              });
        }

        this.betHistory = res.data.data;
        this.rows = res.data.total;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    betDate(time) {
      return moment(time).format('l');
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    closeModal() {
      $('#voucher-history').modal('hide');
    },
    currentDraw() {
      const currentHour = new Date().getHours();
      if (currentHour < 12) {
        return '12:00';
      }
      return '4:30';
    },
  },
  watch: {
    searchKeyword() {
      if (this.searchKeyword === '') {
        this.fetchHistory();
      }
    },
    type() {
      if (this.type !== 'threed') {
        this.params.date = moment(new Date()).format('l');
        this.params.draw = this.currentDraw();
      } else {
        this.setLastHalfMonth();
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    this.params.date = moment(new Date()).format('l');
    this.params.draw = this.currentDraw();
    this.fetchHistory();
    this.setOneMonth();
  },
};
</script>
<style scoped>
/* Match History.vue layout; vue-select above table panel */
.history-toolbar {
  position: relative;
  z-index: 50;
  padding-bottom: 1rem;
  overflow: visible;
}

.history-table-panel {
  position: relative;
  z-index: 1;
  padding: 0.75rem 0.5rem 1rem;
}

.history-date-select {
  position: relative;
  z-index: 2;
  flex: 1 1 200px;
  min-width: 0;
  overflow: visible;
}

.history-date-select--draw {
  flex: 1 1 160px;
}

.history-date-select ::v-deep .vs__dropdown-menu {
  z-index: 2000 !important;
}

.history-date-select ::v-deep .vs--open {
  z-index: 2001;
}

.history-type-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.history-pill {
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.45rem 0.65rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #334155;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  -webkit-tap-highlight-color: transparent;
}

.history-pill--active {
  border-color: transparent;
  color: #fff !important;
  background: linear-gradient(135deg, #991b1b 0%, #dc2626 100%);
}

.history-bingo-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.history-bingo-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
}

.history-date-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.history-date-row--betslip {
  align-items: flex-end;
}

.history-date-label {
  margin-bottom: 6px;
  font-size: 0.75rem;
}

.history-search-btn {
  flex: 0 0 auto;
  width: auto !important;
  min-width: 5.5rem;
  min-height: 44px;
  margin-top: 0 !important;
  align-self: flex-end;
}

.history-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 2.5rem 1rem;
}

.history-loading-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
}

.history-table-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 12px;
}

.betslip-data-table {
  width: 100%;
  min-width: 520px;
  margin-bottom: 0;
  font-size: 0.8rem;
}

.betslip-th {
  white-space: nowrap;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0 !important;
  padding: 0.65rem 0.5rem !important;
  background: #f8fafc;
}

.betslip-data-table__row {
  cursor: pointer;
  transition: background 0.12s ease;
}

.betslip-data-table__row:hover {
  background: #fef2f2;
}

.betslip-data-table__td {
  vertical-align: middle;
  padding: 0.6rem 0.5rem !important;
  border-color: #f1f5f9 !important;
}

.betslip-data-table__td--center {
  text-align: center;
}

.betslip-data-table__value {
  font-weight: 600;
  color: #1e293b;
}

.betslip-data-table__muted {
  color: #64748b;
  font-size: 0.78rem;
}

.betslip-data-table__summary .betslip-data-table__td {
  border-top: 2px solid #e2e8f0 !important;
  background: #fafafa;
}

.betslip-summary-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #475569;
}

.betslip-pill {
  display: inline-block;
  padding: 0.2rem 0.45rem;
  border-radius: 6px;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
}

.betslip-pill--warn {
  background: #fef3c7;
  color: #b45309;
}

.history-voucher-modal__content {
  border: none;
  border-radius: 16px;
  overflow: hidden;
}

.history-voucher-modal__toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 8px 0;
}

.history-capture-btn {
  flex: 0 0 auto;
  min-height: 36px;
  padding: 0.35rem 0.75rem !important;
  font-size: 0.8rem;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  color: #fff !important;
  background: linear-gradient(135deg, #991b1b 0%, #dc2626 100%) !important;
  box-shadow: none !important;
}

.history-modal-cross {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  padding-top: 4px;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  color: white;
  cursor: pointer;
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .main-wrapper {
    padding: 0 !important;
  }

  .history-search-btn {
    width: 100% !important;
    align-self: stretch;
  }
}
</style>
